import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@services/baseQuery';
import { handleError } from '../../utils/api-error-handling';
import { encryptPayload } from '../../utils/security';

export const tracesApi = createApi({
  reducerPath: 'tracesConfigApi',
  baseQuery: baseQuery,
  tagTypes: ['Traces'],
  endpoints: (builder) => ({
    getTracesList: builder.query({
      query: () => 'traces',
      providesTags: ['Traces'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
      forceRefetch() {
        return true;
      },
      keepUnusedDataFor: 0.0001,
    }),
    getTraceData: builder.query({
      query: (params) => `traces/${params}`,
      providesTags: ['Traces'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
      forceRefetch() {
        return true;
      },
      keepUnusedDataFor: 0.0001,
    }),
    createTrace: builder.mutation({
      query: (payload) => ({
        url: 'traces',
        method: 'POST',
        body: encryptPayload(payload),
      }),
      invalidatesTags: ['Traces'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
    updateTrace: builder.mutation({
      query: (payload) => ({
        url: 'traces',
        method: 'PUT',
        body: encryptPayload(payload),
      }),
      invalidatesTags: ['Traces'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
    resolveTrace: builder.mutation({
      query: (payload) => ({
        url: 'resolveTrace',
        method: 'PUT',
        body: encryptPayload(payload),
      }),
      invalidatesTags: ['Traces'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
    unresolveTrace: builder.mutation({
      query: (payload) => ({
        url: 'unresolveTrace',
        method: 'PUT',
        body: encryptPayload(payload),
      }),
      invalidatesTags: ['Traces'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
    createTracesNotes: builder.mutation({
      query: (payload) => ({
        url: 'tracesNotes',
        method: 'POST',
        body: encryptPayload(payload),
      }),
      invalidatesTags: ['Traces'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
  }),
});

export const {
  useLazyGetTracesListQuery,
  useLazyGetTraceDataQuery,
  useCreateTraceMutation,
  useUpdateTraceMutation,
  useResolveTraceMutation,
  useUnresolveTraceMutation,
  useCreateTracesNotesMutation,
} = tracesApi;
